import axios from 'axios';
window.axios = axios;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
import 'owl.carousel';

import 'bootstrap'
import 'slick-carousel'

import jQuery from 'jquery';
window.$ = jQuery;

window.toastr = require('toastr');


jQuery(document).ready(function(){
    jQuery('#possibilities-slider').owlCarousel({
        lazyLoad:true,
        loop:true,
        nav:true,
        items:3,
        autoplay:true,
        autoplayTimeout:3000,
        autoplayHoverPause:true,
        responsive:{
            0:{
                items:1,
            },
            768:{
                items:2,
            },
            1200:{
                items:2,
            },
            1400:{
                items:3,
            }
        }
    });

    jQuery('#clients-slider').owlCarousel({
        lazyLoad:true,
        loop:true,
        nav:true,
        items:6,
        autoplay:true,
        autoplayTimeout:3000,
        autoplayHoverPause:true,
        responsive:{
            0:{
                items:2,
            },
            768:{
                items:3,
            },
            1200:{
                items:5,
            },
            1400:{
                items:6,
            }
        }
    });

    jQuery('#media-gallery-slider').owlCarousel({
        lazyLoad:true,
        loop:true,
        nav:true,
        items:4,
        autoplay:true,
        autoplayTimeout:3000,
        autoplayHoverPause:true,
        responsive:{
            0:{
                items:1,
            },
            768:{
                items:2,
            },
            1200:{
                items:3,
            },
            1400:{
                items:4,
            }
        }
    });

    jQuery('#testmony-slider').owlCarousel({
        lazyLoad:true,
        loop:true,
        nav:true,
        items:2,
        autoplay:true,
        autoplayTimeout:3000,
        autoplayHoverPause:true,
        responsive:{
            0:{
                items:1,
            },
            992:{
                items:2,
            },
            1400:{
                items:2,
            }
        }
    });

    jQuery('#blog-slider').owlCarousel({
        lazyLoad:true,
        loop:true,
        nav:true,
        items:4,
        autoplay:true,
        autoplayTimeout:3000,
        autoplayHoverPause:true,
        responsive:{
            0:{
                items:1,
            },
            768:{
                items:2,
            },
            1200:{
                items:3,
            },
            1400:{
                items:4,
            }
        }
    });
    
});
